import { render, staticRenderFns } from "./PlanDeskPreview.vue?vue&type=template&id=2afb9e94&scoped=true"
import script from "./PlanDeskPreview.vue?vue&type=script&lang=js"
export * from "./PlanDeskPreview.vue?vue&type=script&lang=js"
import style0 from "./PlanDeskPreview.vue?vue&type=style&index=0&id=2afb9e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb9e94",
  null
  
)

export default component.exports